import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaStatusAcumulado', NominasNominaStatusAcumulado)

function NominasNominaStatusAcumulado($http) {
  this.get = _get
  this.put = _put

  function _get(id_empresa, id_nomina) {
    return $http.get('/api/nominas/nomina/status/acumulado', {
      params: {id_empresa: id_empresa, id_nomina: id_nomina},
      schema: NominasNominaStatusAcumuladoSchema,
    })
  }

  function _put(id_empresa, id_nomina, data) {
    return $http.put('/api/nominas/nomina/status/acumulado', data, {
      params: {id_empresa: id_empresa, id_nomina: id_nomina},
      schema: NominasNominaStatusAcumuladoSchema,
      clearCache: 'nominas',
    })
  }

  let NominasNominaStatusAcumuladoSchema = {
    acumulado_fecha: 'timestamp',
    status_acumulado: 'boolean',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Status/Acumulado.js